/* ============================================================
 * Laqqua Shipping Timer — v2 "Linear"
 * Single source of truth. Config arrives via data-* attributes,
 * populated by snippets/laqqua-shipping-timer.liquid from Theme
 * settings. Edit logic here once; markup in the snippet; copy &
 * numbers in the Theme editor.
 *
 * Stati (uno solo alla volta):
 *   planned   → riga calma "Consegna prevista …"
 *   today     → planned + countdown (solo se ordinando ORA si
 *               spedisce in giornata: il countdown non supera
 *               mai le 24 ore, per costruzione)
 *   urgent    → today sotto la soglia urgenza (colore caldo)
 *   holiday   → blackout: "Spedizioni in pausa" + email
 *   backorder → variante senza scorte ma ordinabile (policy
 *               "continue"): nota dedicata, niente countdown
 * ============================================================ */
(function LaqquaShipTimer() {
  'use strict';

  var TZ = 'Europe/Rome';

  /* ---------- date math (battle-tested, kept verbatim) ---------- */

  function nationalHolidays(year) {
    var fixed = [[0,1],[0,6],[3,25],[4,1],[5,2],[7,15],[10,1],[11,8],[11,25],[11,26]];
    var set = {};
    for (var i = 0; i < fixed.length; i++) { set[dk(year, fixed[i][0], fixed[i][1])] = true; }
    var a=year%19, b=Math.floor(year/100), c=year%100;
    var d=Math.floor(b/4), e=b%4, f=Math.floor((b+8)/25);
    var g=Math.floor((b-f+1)/3), h=(19*a+b-d-g+15)%30;
    var ii=Math.floor(c/4), kk=c%4, l=(32+2*e+2*ii-h-kk)%7;
    var mm=Math.floor((a+11*h+22*l)/451);
    var mo=Math.floor((h+l-7*mm+114)/31);
    var da=((h+l-7*mm+114)%31)+1;
    set[dk(year, mo-1, da)] = true;
    var em = new Date(year, mo-1, da); em.setDate(da+1);
    set[dkd(em)] = true;
    return set;
  }

  function parseBlackouts(str) {
    var out = [], toks = (str || '').split(',');
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i].trim();
      if (!t) continue;
      var seg = t.split(':');
      if (seg.length < 2) continue;
      var s = seg[0].split('-'), e = seg[1].split('-');
      var row = [parseInt(s[0],10), parseInt(s[1],10), parseInt(e[0],10), parseInt(e[1],10)];
      var valid = true;
      for (var k = 0; k < 4; k++) { if (isNaN(row[k])) valid = false; }
      if (!valid) continue;
      if (seg.length >= 3) { var y = parseInt(seg[2],10); if (!isNaN(y)) row.push(y); }
      out.push(row);
    }
    return out;
  }

  function blackoutDates(year, BLACKOUTS) {
    var set = {};
    for (var i = 0; i < BLACKOUTS.length; i++) {
      var b = BLACKOUTS[i];
      if (b.length === 5 && b[4] !== year) continue;
      var cur = new Date(year, b[0]-1, b[1]);
      var end = new Date(year, b[2]-1, b[3]);
      while (cur <= end) { set[dkd(cur)] = true; cur.setDate(cur.getDate() + 1); }
    }
    return set;
  }

  function isInBlackout(date, BLACKOUTS) {
    var m = date.getMonth() + 1, d = date.getDate();
    for (var i = 0; i < BLACKOUTS.length; i++) {
      var b = BLACKOUTS[i];
      if (b.length === 5 && b[4] !== date.getFullYear()) continue;
      var start = b[0]*100+b[1], end = b[2]*100+b[3], cur = m*100+d;
      if (start <= end) { if (cur >= start && cur <= end) return true; }
      else { if (cur >= start || cur <= end) return true; }
    }
    return false;
  }

  function dk(y,m,d) { return y+'-'+(m+1<10?'0':'')+(m+1)+'-'+(d<10?'0':'')+d; }
  function dkd(dt)   { return dk(dt.getFullYear(), dt.getMonth(), dt.getDate()); }
  function mid(d)    { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function isWk(d)   { var x = d.getDay(); return x === 0 || x === 6; }

  function rome() {
    try { return new Date(new Date().toLocaleString('en-US', {timeZone: TZ})); }
    catch(e) { return new Date(); }
  }

  function dayDiff(from, to) {
    return Math.round((mid(to).getTime() - mid(from).getTime()) / 86400000);
  }

  /* ---------- italian formatting ---------- */

  var GG = ['domenica','lunedì','martedì','mercoledì','giovedì','venerdì','sabato'];
  var MM = ['gennaio','febbraio','marzo','aprile','maggio','giugno',
            'luglio','agosto','settembre','ottobre','novembre','dicembre'];

  function fmtDow(d) { return GG[d.getDay()]; }
  function fmtDM(d)  { return GG[d.getDay()] + ' ' + d.getDate() + ' ' + MM[d.getMonth()]; }
  function fmtDMY(d) { return fmtDM(d) + ' ' + d.getFullYear(); }

  /* ---------- icons ---------- */

  var IC_TRUCK = '<svg viewBox="0 0 16 16" fill="none" stroke-linecap="round" stroke-linejoin="round">' +
    '<path class="ico" d="M1.5 4h7.5v7h-7.5z" stroke-width="1.5"/>' +
    '<path class="ico" d="M9 6.5h2.8l2.2 2.5v2H9z" stroke-width="1.5"/>' +
    '<circle class="ico" cx="4.5" cy="12.5" r="1.4" stroke-width="1.3"/>' +
    '<circle class="ico" cx="12" cy="12.5" r="1.4" stroke-width="1.3"/></svg>';

  var IC_CAL = '<svg viewBox="0 0 16 16" fill="none" stroke-linecap="round" stroke-linejoin="round">' +
    '<rect class="ico" x="2" y="3" width="12" height="10.5" rx="1.5" stroke-width="1.5"/>' +
    '<line class="ico" x1="2" y1="6.5" x2="14" y2="6.5" stroke-width="1.3"/>' +
    '<line class="ico" x1="6" y1="1.5" x2="6" y2="3.5" stroke-width="1.3"/>' +
    '<line class="ico" x1="10" y1="1.5" x2="10" y2="3.5" stroke-width="1.3"/></svg>';

  var IC_CLOCK = '<svg viewBox="0 0 16 16" fill="none" stroke-linecap="round" stroke-linejoin="round">' +
    '<circle class="ico" cx="8" cy="8" r="6.5" stroke-width="1.5"/>' +
    '<polyline class="ico" points="8 4.5 8 8 10.5 9.5" stroke-width="1.5"/></svg>';

  /* ---------- countdown copy ---------- */

  function fmtCountdown(secs, withSeconds) {
    var h = Math.floor(secs / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    if (withSeconds) {
      var sp = s + (s === 1 ? ' secondo' : ' secondi');
      if (m > 0) return m + (m === 1 ? ' minuto e ' : ' minuti e ') + sp;
      return sp;
    }
    if (h > 0) {
      var hp = h + (h === 1 ? ' ora' : ' ore');
      return m > 0 ? (hp + ' e ' + m + (m === 1 ? ' minuto' : ' minuti')) : hp;
    }
    if (m > 0) return m + (m === 1 ? ' minuto' : ' minuti');
    return 'meno di 1 minuto';
  }

  /* ---------- template fill ({data} {countdown} {giorno} {email}) ---------- */

  function tpl(str, map) {
    return String(str || '').replace(/\{(data|countdown|giorno|email)\}/g, function (_, key) {
      return map[key] != null ? map[key] : '';
    });
  }

  /* ---------- per-element controller ---------- */

  function init(el) {
    if (el.getAttribute('data-initialized') === 'true') return;
    el.setAttribute('data-initialized', 'true');

    var cutH      = clampInt(el.getAttribute('data-cutoff-hour'), 0, 23, 12);
    var minD      = Math.max(1, clampInt(el.getAttribute('data-min-days'), 1, 60, 1));
    var maxD      = Math.max(minD, clampInt(el.getAttribute('data-max-days'), 1, 60, 2));
    var bufferSec = clampInt(el.getAttribute('data-buffer-minutes'), 0, 240, 10) * 60;
    var urgentH   = clampInt(el.getAttribute('data-urgent-hours'), 1, 48, 6);
    var optimistic    = el.getAttribute('data-date-style') !== 'range';
    var useCountdown  = el.getAttribute('data-countdown') !== 'false';
    var secondsLastHr = el.getAttribute('data-seconds-last-hour') === 'true';
    var compact   = el.getAttribute('data-compact') === 'true';
    var email     = el.getAttribute('data-support-email') || 'support@laqqua.com';
    var BLACKOUTS = parseBlackouts(el.getAttribute('data-blackouts'));

    var TXT = {
      hero:           el.getAttribute('data-txt-hero')           || 'Ricevilo {data}',
      sub:            el.getAttribute('data-txt-sub')            || 'Ordina entro {countdown}',
      holidayTitle:   el.getAttribute('data-txt-holiday-title')  || 'Spedizioni in pausa',
      holidaySub:     el.getAttribute('data-txt-holiday-sub')    || 'Riprendono dal primo giorno lavorativo utile. Scrivici a {email}.',
      backorderTitle: el.getAttribute('data-txt-backorder-title') || 'Disponibile su ordinazione',
      backorder:      el.getAttribute('data-txt-backorder')      || 'Potrebbe essere spedito qualche giorno dopo il resto dell’ordine. Il costo di spedizione non cambia.'
    };
    // the drawer line speaks about the whole cart, not a single product
    if (compact) {
      TXT.hero = el.getAttribute('data-txt-compact') || 'Consegna prevista {data}';
    }

    var cache = {};
    function closedSet(year) {
      if (!cache[year]) {
        var h = nationalHolidays(year), b = blackoutDates(year, BLACKOUTS);
        for (var key in b) { h[key] = true; }
        cache[year] = h;
      }
      return cache[year];
    }
    function isClosed(d) { return isWk(d) || !!closedSet(d.getFullYear())[dkd(d)]; }
    function isOpen(d)   { return !isClosed(d); }
    function nextOpen(d) { var r = new Date(d); do { r.setDate(r.getDate()+1); } while (!isOpen(r)); return r; }
    function addOpen(d,n){ var r = new Date(d); while(n>0){ r.setDate(r.getDate()+1); if(isOpen(r)) n--; } return r; }

    var tid = null;

    // Single linear column: icon + hero line + optional sub line.
    // Compact (drawer) is a quiet sub-line under the cart title: no icon
    // (it would indent the text off the title's left edge), muted colour —
    // metadata, not a sibling heading.
    // ⚠️ Si scrive nel DOM SOLO se qualcosa è cambiato. Ogni scrittura, anche
    // identica, sveglia i MutationObserver di mezzo sito (la scansione GA4 su
    // tutto il body, i due osservatori del cassetto, Clarity): riscrivere la
    // stessa riga una volta al secondo costava 30-50 ms al secondo sul Mac,
    // tre o quattro volte tanto su un Android medio (audit del 22 set 2026).
    var lastHTML = null;
    function card(icon, heroHTML, subHTML, mode) {
      var html =
        (compact ? '' : '<span class="lq-ship__pill">' + icon + '</span>') +
        '<div class="lq-ship__body">' +
          '<div class="lq-ship__hero">' + heroHTML + '</div>' +
          (subHTML && !compact ? '<div class="lq-ship__sub">' + subHTML + '</div>' : '') +
        '</div>';
      if (el.getAttribute('data-mode') !== mode) el.setAttribute('data-mode', mode);
      if (html !== lastHTML) { el.innerHTML = html; lastHTML = html; }
      if (el.getAttribute('data-state') !== 'ready') el.setAttribute('data-state', 'ready');
    }

    function renderHoliday() {
      var emailLink = '<a class="lq-ship__email" href="mailto:' + email + '">' + email + '</a>';
      card(IC_CAL, TXT.holidayTitle, tpl(TXT.holidaySub, { email: emailLink }), 'holiday');
    }

    function isBackorder() {
      if (el.getAttribute('data-backorder-enabled') !== 'true') return false;
      if (el.getAttribute('data-autostock') === 'true') return true;
      var policy = el.getAttribute('data-inventory-policy');
      var qty = parseInt(el.getAttribute('data-inventory-quantity'), 10);
      return policy === 'continue' && !isNaN(qty) && qty <= 0;
    }

    function renderBackorder() {
      if (tid) { clearTimeout(tid); tid = null; }
      card(IC_CLOCK, TXT.backorderTitle, TXT.backorder, 'backorder');
    }

    // non-breaking spaces: the date is one typographic unit — if the line
    // must wrap, it wraps before the date, never inside it (no orphans)
    function glue(s) { return s.replace(/ /g, ' '); }
    function dayN(d) { return d.getDate() === 1 ? '1°' : String(d.getDate()); }

    function arrivalDateStr(effBase, now) {
      var fromDate = addOpen(effBase, minD);
      var toDate   = addOpen(effBase, maxD);

      if (optimistic || mid(fromDate).getTime() === mid(toDate).getTime()) {
        var diff = dayDiff(now, fromDate);
        var crossYear = fromDate.getFullYear() !== now.getFullYear();
        var full = crossYear ? fmtDMY(fromDate) : fmtDM(fromDate);
        var dowDay = fmtDow(fromDate) + ' ' + fromDate.getDate();
        if (diff === 0)      return glue('oggi ' + dowDay);
        if (diff === 1)      return glue('domani ' + dowDay);
        return glue(full);
      }

      // range: no weekday names — shorter line, the span is the message.
      // Each date is glued on its own: if the line must wrap, it breaks
      // before the "e", giving two balanced halves instead of an orphan.
      var sameMonth = fromDate.getMonth() === toDate.getMonth() && fromDate.getFullYear() === toDate.getFullYear();
      var crossY = toDate.getFullYear() !== now.getFullYear();
      var toStr = dayN(toDate) + ' ' + MM[toDate.getMonth()] + (crossY ? ' ' + toDate.getFullYear() : '');
      var fromStr = sameMonth ? dayN(fromDate) : dayN(fromDate) + ' ' + MM[fromDate.getMonth()];
      return glue('tra il ' + fromStr) + ' ' + glue('e il ' + toStr);
    }

    function render() {
      if (isBackorder()) { renderBackorder(); return; }

      var now = rome();
      var today = mid(now);

      if (isInBlackout(today, BLACKOUTS)) {
        renderHoliday();
        var tomorrow = new Date(today); tomorrow.setDate(today.getDate()+1);
        schedule(Math.min(tomorrow - now + 2000, 3600000));
        return;
      }

      var base = today;
      if (!isOpen(base)) base = nextOpen(base);

      var cut = new Date(base.getFullYear(), base.getMonth(), base.getDate(), cutH, 0, 0);
      if (now >= cut) {
        base = nextOpen(base);
        cut = new Date(base.getFullYear(), base.getMonth(), base.getDate(), cutH, 0, 0);
      }

      // buffer: if the cutoff is too close, assume the order ships the next open day
      var effBase = base, deadline = cut;
      var secsToCut = Math.floor(Math.max(0, cut - now) / 1000);
      if (secsToCut <= bufferSec && secsToCut > 0) {
        effBase = nextOpen(base);
        deadline = new Date(effBase.getFullYear(), effBase.getMonth(), effBase.getDate(), cutH, 0, 0);
      }

      var secsToDeadline = Math.floor(Math.max(0, deadline - now) / 1000);
      var hoursToDeadline = secsToDeadline / 3600;
      var heroHTML = tpl(TXT.hero, { data: arrivalDateStr(effBase, now) });

      // The countdown lever fires ONLY when ordering now still ships today —
      // the one moment the clock changes the decision. By construction it can
      // never exceed 24h (no "ordina entro 72 ore" on a Friday).
      var shipsToday = mid(deadline).getTime() === today.getTime() && secsToDeadline > 0;

      if (!shipsToday || !useCountdown) {
        card(IC_TRUCK, heroHTML, '', 'planned');
        schedule(60000);
        return;
      }

      // ⚠️ `<` e non `<=`. A ESATTAMENTE un'ora dalla scadenza (3600s) il
      // formato a secondi guarda solo minuti e secondi — che lì valgono zero
      // entrambi — e la card scriveva «Ordina entro 0 secondi», cioè il
      // contrario di quello che voleva dire, per un secondo al giorno. Sotto i
      // 3600 il minuto c'è sempre, quindi la frase torna sensata.
      // In versione compatta (cassetto) la riga del conto alla rovescia non si
      // disegna proprio: i secondi non si vedono, quindi niente tic al secondo.
      var showSeconds = secondsLastHr && !compact && secsToDeadline < 3600;
      var urgent = hoursToDeadline <= urgentH;
      var mode = urgent ? 'urgent' : 'today';
      var cd = '<span class="lq-ship__cd">' + fmtCountdown(secsToDeadline, showSeconds) + '</span>';
      var arrivalDate = addOpen(effBase, minD);
      var arrivalDiff = dayDiff(now, arrivalDate);
      var arrivalWhen = arrivalDiff === 0 ? 'oggi' : (arrivalDiff === 1 ? 'domani' : fmtDow(arrivalDate));
      var subHTML = tpl(TXT.sub, { countdown: cd, giorno: arrivalWhen });

      card(IC_TRUCK, heroHTML, subHTML, mode);

      if (showSeconds) {
        schedule(1000);
      } else {
        var toMin = 60 - (secsToDeadline % 60);
        schedule((toMin === 0 ? 60 : toMin) * 1000);
      }
    }

    function schedule(ms) {
      if (tid) clearTimeout(tid);
      tid = setTimeout(render, ms);
    }

    render();

    function onVis() { if (!document.hidden) render(); }
    document.addEventListener('visibilitychange', onVis);

    // re-render on inventory attribute changes (variant switch bridge)
    var attrObs = null;
    if (typeof MutationObserver !== 'undefined') {
      attrObs = new MutationObserver(function () { render(); });
      attrObs.observe(el, {
        attributes: true,
        attributeFilter: ['data-autostock', 'data-inventory-policy', 'data-inventory-quantity']
      });
    }

    if (typeof MutationObserver !== 'undefined' && el.parentNode) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var removed = muts[i].removedNodes;
          for (var j = 0; j < removed.length; j++) {
            if (removed[j] === el || (removed[j].contains && removed[j].contains(el))) {
              if (tid) clearTimeout(tid);
              obs.disconnect();
              if (attrObs) attrObs.disconnect();
              document.removeEventListener('visibilitychange', onVis);
              return;
            }
          }
        }
      });
      obs.observe(el.parentNode, { childList: true, subtree: true });
    }
  }

  function clampInt(v, lo, hi, dflt) {
    var n = parseInt(v, 10);
    if (isNaN(n)) return dflt;
    return Math.min(hi, Math.max(lo, n));
  }

  function bootAll() {
    var nodes = document.querySelectorAll('.lq-ship[data-shipping-timer]');
    for (var i = 0; i < nodes.length; i++) { init(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else { bootAll(); }

  // catch timers injected after load (e.g. cart drawer re-render)
  if (typeof MutationObserver !== 'undefined' && !window.__lqShipBootObs) {
    window.__lqShipBootObs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.lq-ship[data-shipping-timer]')) { init(n); }
          else if (n.querySelectorAll) {
            var inner = n.querySelectorAll('.lq-ship[data-shipping-timer]');
            for (var k = 0; k < inner.length; k++) { init(inner[k]); }
          }
        }
      }
    });
    window.__lqShipBootObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  // safety: never leave the loading skeleton stuck
  setTimeout(function () {
    var nodes = document.querySelectorAll('.lq-ship[data-shipping-timer][data-state="loading"]');
    for (var i = 0; i < nodes.length; i++) { nodes[i].style.display = 'none'; }
  }, 3000);

  // re-init when dropped into the theme editor
  document.addEventListener('shopify:section:load', bootAll);
})();
